import { useEffect, useRef, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { MdClose, MdMenu } from "react-icons/md";
import { useNavigate } from 'react-router';

import Usa from '../assets/ico/usa.svg'
import { useOutsideFinder } from "./useOutsideFinder";
// import Fr from '../assets/ico/fr.svg'
// import Sp from '../assets/ico/spain.svg'
// import Sw from '../assets/ico/sw.svg'

export default function Header({page}) {
    const [show, setShow] = useState(false)
    const navigate = useNavigate();
    const divRef = useRef()

    const UsaIcon = () => <img src={Usa} alt="USA Flag" className="w-6 h-6 object-contain" />;
    // const FrIcon = () => <img src={Fr} alt="Fr Flag" className="w-6 h-6 object-contain" />;
    // const SpIcon = () => <img src={Sp} alt="Sp Flag" className="w-6 h-6 object-contain" />;
    // const SwIcon = () => <img src={Sw} alt="Sp Flag" className="w-6 h-6 object-contain" />;

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;

            // Définir une valeur seuil pour le changement de style
            const threshold = 100;

            setIsScrolled(scrollTop > threshold);
        };

        // Attacher l'événement de défilement
        window.addEventListener('scroll', handleScroll);

        // Nettoyer l'événement lors du démontage du composant
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const Items = () => {

        const Item = ({ action, name, children }) => {
            return (
                <div onClick={action} className={`flex items-center justify-between lg:p-0 p-3 cursor-pointer hover:lg:bg-${isScrolled ? 'white' : 'transparent'} lg:hover:bg-transparent sm:hover:bg-[#87ceeb] `}>
                    <label className={`cursor-pointer lg:hover:text-[#87ceeb] hover:text-black ${page === "ADMIN" || isScrolled ? 'lg:text-black' : 'lg:text-white'} lg:hover:underline`}>
                        {!children ? name : children}
                    </label>
                    <span className="lg:hidden">
                        <FaArrowRight className="" size={20} />
                    </span>
                </div>
            )
        }

        return (
            <>
                <Item name={'Home'} action={() => { navigate('/') }} />
                <Item name={'Location'} action={() => { navigate('/Location') }} />
                <Item name={'Contact Us'} action={() => { navigate('/Contact') }} />
                <Item name={'Sponsor a child'} action={() => { navigate('/Sponsor') }} />
                <Item name={'Education'} action={() => { navigate('/Education') }} />
                <Item name={'Donate today'} action={() => { navigate('/Donate') }} />
                <Item name={'About Us'} action={() => { navigate('/about') }} />
                <Item name={'Visit Congo'} action={() => { navigate('/VisitCongo') }} />
                <Item name={"What's New"} action={() => { navigate('/News') }} />
                <Item>
                    <div className="flex items-center gap-2">
                        <span className="lg:hidden">Language</span> <UsaIcon />
                    </div>
                </Item>

                <div className="flex md:order-2">
                </div>
            </>
        )
    }

    useOutsideFinder(() => setShow(false), divRef)
    return (
        <div id='header' className={`bg-${page === "ADMIN" || isScrolled ? 'white' : 'transparent'} shadow-xl sm:h-24 h-20 flex items-center justify-between 2xl:px-80 xl:px-52 px-10 fixed top-0 w-full z-10 ${!show ? 'rounded-b-[3rem]' : 'rounded-bl-[3rem]'}`}>
            <div className='font-extrabold italic uppercase text-2xl text-[#87ceeb]'>
                ACRFI
            </div>

            <div className=' lg:flex hidden ml-4 items-center gap-3 rounded-full'>
                <Items />
            </div>


            <div className="lg:hidden flex" ref={divRef}>
                {!show ?
                    <MdMenu className={`text-[#87ceeb] cursor-pointer bg-${isScrolled ? 'white' : 'transparent'} hover:shadow-xl rounded-2xl`} size={30} onClick={() => { setShow(true) }} />
                    :
                    <MdClose className={`text-red-500 cursor-pointer bg-${isScrolled ? 'white' : 'transparent'} hover:shadow-xl rounded-2xl`} size={30} onClick={() => { setShow(false) }} />
                }
                <div ref={divRef} className={` w-[200px ${show ? 'flex animate-slide-in' : 'hidden '} bg-blue-50 shadow-xl z-50 right-0 sm:top-24 top-20 rounded-bl-3xl fixed flex-col `}>
                    <Items />
                </div>
            </div>
        </div>
    )
}